import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ProperSpinner from "../../components/spinner/ProperSpinner";
import DetailCard from "../../components/siteDetailCard";
import ImgSlider from "../../components/imgSlider";
import { useLocation } from "react-router-dom";
import { feedbackStatusHandler, getFeedbackDetails } from "./actions";
import { dateFormatter, isImage, isVideo } from "../../utils/commonFunctions";
import ImagePreviewer from "../../components/imgSlider/ImagePreviewer";
import { MdVerifiedUser } from "react-icons/md";
import CustomModal from "../../components/customModal";

const FeedbackDetails = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const segments = pathname.split("/");
  const feedbackId = segments[segments.length - 1];

  const [loading, setLoading] = React.useState(false);
  const [feedbackDetails, setFeedbackDetails] = React.useState({});
  const [visible, setVisible] = useState(false);
  const [selectedPostIdx, setSelectedPostIdx] = useState(0);
  const [modal, setModal] = useState(false);

  const modalClose = () => {
    setModal(false);
  };

  const isActiveHandler = () => {
    console.log("active handler called");
    dispatch(
      feedbackStatusHandler(feedbackDetails?._id, (response) => {
        console.log("response", response);
        setFeedbackDetails((prev) => ({
          ...prev,
          status: 4,
        }));
      })
    );
    modalClose();
  };

  const renderModalBody = () => {
    return (
      <p className="text-center pt-2">
        Are you sure want to marked as{" "}
        <span className="highlight--text">Completed</span>?
      </p>
    );
  };

  React.useEffect(() => {
    setLoading(true);
    dispatch(
      getFeedbackDetails(feedbackId, (response) => {
        setLoading(false);
        setFeedbackDetails(response);
      })
    );
  }, []);

  if (loading) {
    return <ProperSpinner />;
  }
  const userName =
    `${feedbackDetails?.userData?.firstName || ""} ${feedbackDetails?.userData?.lastName || ""}`.trim() ||
    "N/A";
  const email = feedbackDetails?.userData?.email || "N/A";

  const medias = [];
  feedbackDetails?.media?.forEach((media, i) => {
    if (isImage(media)) {
      medias.push({
        src: media,
        alt: `Image ${i}`,
      });
    } else if (isVideo(media)) {
      const ext = media?.split(".").pop();
      medias.push({
        type: "video",
        width: 1280,
        height: 720,
        sources: [
          {
            src: media,
            type: `video/${ext}`,
          },
        ],
      });
    }
  });
  console.log("feed back details :", feedbackDetails);
  return (
    <div>
      <div className="site-det-wrapper">
        <div className="d-flex justify-content-end align-items-center ">
          {feedbackDetails?.status && (
            <div
              style={{
                cursor:
                  feedbackDetails?.status === 1 ? "pointer" : "not-allowed",
              }}
              {...(feedbackDetails?.status === 1 && {
                onClick: () => setModal(true),
              })}
              className={`site-details-btns ${feedbackDetails?.status === 4 ? "site-success-btn" : "site-warning-btn"}`}
            >
              {feedbackDetails?.status === 1
                ? "mark as Completed"
                : "Completed"}
              <MdVerifiedUser className="lg-icon" />
            </div>
          )}
        </div>
        <CustomModal
          visible={modal}
          visibleHandler={modalClose}
          heading={"Confirmation"}
          body={() => renderModalBody()}
          confirmHandler={() =>
            isActiveHandler(feedbackDetails?._id, feedbackDetails?.status)
          }
          modalSize="md"
          confirmText={"Yes, Completed"}
          footershow={true}
          closeText="Cancel"
        />
        <div className="site-content-container ">
          <div className="slider-container ">
            {feedbackDetails?.media?.length > 0 && (
              <>
                <ImgSlider
                  Images={[...feedbackDetails.media]}
                  size={"small"}
                  setSelectedPostIdx={setSelectedPostIdx}
                  setVisible={setVisible}
                  selectedPostIdx={selectedPostIdx}
                />
                <ImagePreviewer
                  medias={medias}
                  visible={visible}
                  setVisible={setVisible}
                  selectedPostIdx={selectedPostIdx}
                  setSelectedPostIdx={setSelectedPostIdx}
                />
              </>
            )}
          </div>
          <div className="site-details-main-container">
            <div className="site-info-contaianer">
              <div className="site-details-container-1 ">
                <div className="personal-info-container">
                  <h4 className="label-text heading text-underline ">
                    {"Post Details"}
                  </h4>

                  <div className="site-data-container">
                    <DetailCard
                      data={feedbackDetails?.type}
                      label={"Feedback Type"}
                    />
                    <DetailCard
                      data={feedbackDetails?.feedback || "N/A"}
                      label={"Feedback message"}
                    />
                    <DetailCard
                      data={
                        feedbackDetails.status === 4 ? "Completed" : "Pending"
                      }
                      label={"Status"}
                    />
                    <DetailCard
                      data={dateFormatter(feedbackDetails.createdAt)}
                      label={"Created At"}
                    />
                  </div>
                </div>
              </div>
              <div className="site-details-container-1 ">
                <div className="personal-info-container">
                  <h4 className="label-text heading text-underline ">
                    {"User Details"}
                  </h4>

                  <div className="site-data-container">
                    <DetailCard data={userName} label={"Full name"} />
                    <DetailCard data={email} label={"Email"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackDetails;
